import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import {BaNotificationService} from '../../services/ba-notification.service';
//import {MatIconModule} from '@angular/material/icon';
import { HeaderService } from '../../../core/services/header.service';
import { Router } from '@angular/router';
import { Constants } from '../../shared.constants';

@Component({
    selector: 'ba-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.css'],
    standalone: false
})
export class BaNotificationComponent implements OnInit {
  //ui inputs
  @Input()
  maxNoOfRecords: Number;
  @Input()
  defaultbehaviour: Boolean;
  @Output() onBtnClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() onMsgOpen: EventEmitter<any> = new EventEmitter<any>();

  notificationData:any ={};

   constructor(private service:BaNotificationService,private router: Router,
   private headerService: HeaderService ) {
    this.notificationData = this.service.notificationData;
   }

  ngOnInit() {
    this.maxNoOfRecords = 5;
    this.service.setMaxRecords(this.maxNoOfRecords);
    this.service.updateUi();    
  }

  notificationClick(notificationObj: any){
    this.headerService.performAction('notificationIcon');
    this.onMsgOpen.emit(notificationObj);
    //console.log(notificationObj);
    
    var metadata = JSON.parse(notificationObj.metaData);

    //this is for TPE module notification
    if(metadata["module"]=="TPE"){
      if( metadata["type"]=="task"){
        if(metadata["taskType"] =="model"){
          var projectId = metadata["projectId"];
          var modelId = metadata["modelId"];
          this.service.markAsRead(notificationObj.seqId);
          this.router.navigate([Constants.MODEL_DETAIL_ROUTE_URL + projectId + "/" + modelId + "/me"]);
        }
        else if(metadata["taskType"] =="eda"){
          var projectId = metadata["projectId"];
          var modelId = metadata["modelId"];
          this.service.markAsRead(notificationObj.seqId);
          this.router.navigate([Constants.EDA_DETAIL_ROUTE_URL + projectId + "/" + modelId + "/me"]);
        } 
        else  if(metadata["taskType"]=="timeSeries"){
          var projectId = metadata["projectId"];
          var modelId = metadata["modelId"];
          this.service.markAsRead(notificationObj.seqId);
          this.router.navigate([Constants.TIME_SERIES_DETAIL_ROUTE_URL + projectId + "/" + modelId + "/me"]);
        }   
        else  if(metadata["taskType"]=="fva"){
          var projectId = metadata["projectId"];
          this.service.markAsRead(notificationObj.seqId);
          this.router.navigate([Constants.PROJECT_DETAIL_ROUTE_URL + projectId]);
        }         
      }
      else  if(metadata["type"]=="chart"){
        var projectId = metadata["projectId"];
        var modelId = metadata["modelId"];
        this.service.markAsRead(notificationObj.seqId);
        this.router.navigate([Constants.MODEL_DETAIL_ROUTE_URL + projectId + "/" + modelId + "/me"]);
      }                   
    }
    //this.notificationService.markAsRead(notificationObj.seqId);
  }

  pageChanged(event:PageEvent){
    this.service.updateNotificationUnreadList(event.pageIndex);
  }

  footerBtnClicked(){
    this.onBtnClick.emit({});
    this.router.navigate([Constants.TPE_NOTIFICATION_LIST_ROUTE_URL]);
  }
}
